import { render, staticRenderFns } from "./RelationModule.vue?vue&type=template&id=72c36f4e&scoped=true&"
import script from "./RelationModule.vue?vue&type=script&lang=js&"
export * from "./RelationModule.vue?vue&type=script&lang=js&"
import style0 from "./RelationModule.vue?vue&type=style&index=0&id=72c36f4e&lang=scss&scoped=true&"
import style1 from "./RelationModule.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c36f4e",
  null
  
)

export default component.exports